/**
 * 模拟art-template API 实现了基础的 {{}} 内取数据的模板功能
 * 支持返回对象，函数,布尔值
 * 模板数据：let source={
            "order.name":"{{order.sex}}/dddk/{{order.name}}",
            "order.sex":"{{order.title}}",
            "order.title":"{{order.title.good + order.name}}",
            "order.good":"{{function(local){return local.max+'你的微笑'}(local)}}",
            "order.max":"{{$imports.objectUtil(order)}}",
            "order.min":true,
            "order.obj":{name:"{{order.title}}"},
            "order.true":"{{order.title.show}}"
        };
    要取的数据：const tdata={
            order:{
                name:'周杰伦',
                sex:'性别',
                title:{
                    good:'好东西',
                    show:true
                }
            },
            local:{
                max:100
            }
        }

    执行下面这句
    compileData(source,tdata)
    返回的结果：
    {
        order.good: "100你的微笑",
        order.max: "周杰伦发低烧",
        order.min: true,
        order.name: "性别/dddk/周杰伦",
        order.obj: {
            name: {
                good:'好东西',
                show:true
            }
        },
        order.sex: {good: "好东西", show: true},
        order.title: "好东西周杰伦",
        order.true: true,
    }
 */

import * as objectUtil from './object'
import * as arrayUtils from './array'
import * as urlUitls from './url'
import * as calculateUtils from './calculate'
import { filters } from './filters'
import { templateMethods } from 'pangu-core'

const REG = /\{\{(.+?)\}\}/g
const REG1 = /^\{\{(.+?)\}\}$/g
const REG2 = /^\{(.+?)\}$/g

// 有且只有1个 双大括号{{}}时
const isSingle = function (source) {
  const mt = source.match(REG)
  const mt1 = source.match(REG1)
  if (mt && mt1 && mt.length === mt1.length) {
    return true
  } else {
    return false
  }
}

const getTemplateData = function (item, args, argsData) {
  const reg = new RegExp(REG1)
  reg.exec(item)
  let tem = RegExp.$1
  tem.replace(/\n|\t/g, '')
  try {
    const fn = new Function(...args, `return ${tem}`)
    return fn.apply(null, argsData)
  } catch (e) {
    console.error(`${e.name}: {{${tem}}} >> ${e.message}`)
    return null
  }
}

const forSourceObj = function (_source, args, argsData) {
  const resObj = _source instanceof Array ? [] : {}
  for (let key in _source) {
    if (_source.hasOwnProperty(key)) {
      let itemValue = _source[key]
      if (typeof itemValue === 'object' && itemValue !== null) {
        resObj[key] = forSourceObj(itemValue, args, argsData)
      } else if (typeof itemValue === 'string') {
        let newValue
        if (isSingle(itemValue)) {
          newValue = getTemplateData(itemValue, args, argsData)
        } else {
          if (itemValue === 'true') {
            // 解决配置里面，传入的是字符串 "true" 引起报错
            newValue = true
          } else if (itemValue === 'false') {
            newValue = false
          } else {
            newValue = itemValue.replace(REG, (item) => {
              return getTemplateData(item, args, argsData)
            })
          }
        }
        resObj[key] = newValue
      } else {
        resObj[key] = itemValue
      }
    }
  }
  return resObj
}

const imports = {
  objectUtil,
  arrayUtils,
  urlUitls,
  calculateUtils,
  // 支持以 $.getValue(data,path)方式取数据简洁点不用写那么长，兼容老版本取数据方式
  getValue(obj, path, defaultValue = null, isObj) {
    return objectUtil.getValueByPath(obj, path, defaultValue, isObj)
  },
  setValue(obj, path, value) {
    return objectUtil.setValueByPath(obj, path, value)
  },
  deleteValue(obj, path) {
    return objectUtil.deleteByPath(obj, path)
  },
  containValue(obj, path, containArray) {
    return objectUtil.containOrValueByPath(obj, path, containArray)
  },
  getSelectByPath(source, selects, path) {
    return arrayUtils.getSelectByPath(source, selects, path)
  },
  getKeysByPath(source, path) {
    return arrayUtils.getKeysByPath(source, path)
  },
  getKeysByPathValue(source, path, value) {
    return arrayUtils.getKeysByPathValue(source, path, value)
  },
  filters,
  ...templateMethods,
}

export function compileData(source, data) {
  if (!source || !data) return source
  let _source = source
  const args = Object.keys(data)
  const argsData = args.map((item) => data[item])
  args.push('$imports', '$')
  argsData.push(imports, imports)
  if (typeof _source === 'string') {
    // 给模板表达式去首尾空格
    _source = _source.replace(/(^\s*)|(\s*$)/g, '')
    if (isSingle(_source)) {
      return getTemplateData(_source, args, argsData)
    } else {
      const mt2 = _source.match(REG2)
      if (mt2 && mt2.length) {
        try {
          _source = JSON.parse(_source)
        } catch (e) {
          console.error(`${e.name}: ${e.message}`)
        }
      } else {
        return _source.replace(REG, (item) => {
          return getTemplateData(item, args, argsData)
        })
      }
    }
  }
  return forSourceObj(_source, args, argsData)
}
